module.exports = __webpack_public_path__ + "static/media/엽서섬네일 (3).1b3a2293.PNG";